import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const TimerIcon: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  isFilled,
  fillOpacity,
}) => {
  const path = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.329 3.733A.73.73 0 0 1 10.057 3h3.886a.73.73 0 0 1 .728.733.73.73 0 0 1-.728.732h-1.214v2.473a8.462 8.462 0 0 1 4.384 1.688l.693-.698a.736.736 0 0 1 .155-.806.726.726 0 0 1 1.03 0l.324.325.324.326a.735.735 0 0 1 0 1.036.726.726 0 0 1-.802.155l-.638.642a8.588 8.588 0 0 1-.188 11.891 8.497 8.497 0 0 1-2.758 1.852 8.46 8.46 0 0 1-9.263-1.852 8.55 8.55 0 0 1-1.843-2.773A8.587 8.587 0 0 1 5.99 9.41a8.497 8.497 0 0 1 5.281-2.472V4.465h-1.214a.73.73 0 0 1-.728-.732zm-1.056 8.224a.726.726 0 0 1 1.03.053l3.238 3.604c.27.3.246.763-.053 1.034a.726.726 0 0 1-1.029-.052l-3.238-3.604a.735.735 0 0 1 .053-1.035z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.329 2.733A.73.73 0 0 1 10.057 2h3.886a.73.73 0 0 1 .728.733.73.73 0 0 1-.728.732h-1.214v2.473a8.462 8.462 0 0 1 4.384 1.688l.693-.698a.736.736 0 0 1 .155-.806.726.726 0 0 1 1.03 0l.324.325.324.326a.735.735 0 0 1 0 1.036.726.726 0 0 1-.802.155l-.638.642a8.588 8.588 0 0 1-.188 11.891 8.497 8.497 0 0 1-2.758 1.852 8.46 8.46 0 0 1-9.263-1.852 8.55 8.55 0 0 1-1.843-2.773A8.587 8.587 0 0 1 5.99 8.41a8.497 8.497 0 0 1 5.281-2.472V3.465h-1.214a.73.73 0 0 1-.728-.732zM12 7.373a7.01 7.01 0 0 0-4.98 2.073 7.114 7.114 0 0 0 0 10.015A7.039 7.039 0 0 0 12 21.535a7.01 7.01 0 0 0 4.98-2.074 7.087 7.087 0 0 0 2.063-5.007 7.115 7.115 0 0 0-2.063-5.008A7.01 7.01 0 0 0 12 7.372zm-3.726 3.584a.726.726 0 0 1 1.029.053l3.238 3.604c.27.3.246.763-.053 1.034a.726.726 0 0 1-1.029-.052l-3.238-3.604a.735.735 0 0 1 .053-1.035z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper viewBox={viewBox} size={size}>
      {path}
    </SvgWrapper>
  )
}

export default TimerIcon
